export class Alert{
  constructor(
    public state:string,
    public level:string,
    public message:string
  ){}

  update(state:string, level:string, message:string){
    this.state = state;
    this.level = level;
    this.message = message;
  }
}



// WEBPACK FOOTER //
// ./src/app/alert/alert.ts